module.exports = __webpack_public_path__ + "assets/img/icon_replay.74875dd4.svg";